/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEmailRequest } from '../../models/update-email-request';
import { UpdateEmailResult } from '../../models/update-email-result';

export interface PatchAccountEmail$Params {
  body?: UpdateEmailRequest;
}

export function patchAccountEmail(
  http: HttpClient,
  rootUrl: string,
  params?: PatchAccountEmail$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UpdateEmailResult>> {
  const rb = new RequestBuilder(rootUrl, patchAccountEmail.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateEmailResult>;
    }),
  );
}

patchAccountEmail.PATH = '/Authentication/account-email';
